import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "fn_unfinished_auction-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "fn_unfinished_auction-modal-label",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = ["href"]

import {ref, watch, onMounted, computed} from 'vue'
import Modal from 'bootstrap.native/src/components-v4/modal-native';
import {formatCurrency} from "@weseus/cms-core/assets/js/helpers";


export default {
  __name: 'unfinishedAuctions',
  props: {
	showModal: { required: true },
	auction: { required: true },
	user: { required: true },
	rechargeAmount: { required: true },
	currencyCode: { required: true },
	urlRechargeWallet: { required: true },
},
  emits: ['submit', 'closed'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit;

const rechargeAmountFormatted = computed(() => {
	return formatCurrency(props.rechargeAmount, props.currencyCode, 'cs');
});

let modal = null;

onMounted(() => {
	const modalEl = document.getElementById('fn_unfinished_auction-modal');
	if (modal === null) {
		modal = new Modal(modalEl);
		modalEl.addEventListener('hide.bs.modal', () => {
			emit('closed');
		});
	}
});

watch(() => props.showModal, (newVal, oldVal) => {
	if (newVal) {
		modal.show();
	} else {
		modal.hide();
		emit('closed');
	}
})


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"modal-header\"><p class=\"modal-title h1 mb-0\" id=\"fn_unfinished_auction-modal-label\">Před příhozem je nutné dobít peněženku</p><button type=\"button\" class=\"modal-close\" data-dismiss=\"modal\" aria-label=\"Zavřít\"></button></div><div class=\"modal-body\"><p class=\"mb-0\">Jelikož u nás máte vyhrané nedokončené aukce je před dalším příhozem nutné dobít peněženku na částku příhozu + poplatku za bezpečnou platbu. Částka v peněžence bude blokována po dobu, kdy budete vyhrávat aukci. Po skončení částkou aukci zaplatíte. Děkujeme za pochopení.</p></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-dismiss": "modal"
          }, "Zavřít", -1 /* HOISTED */)),
          _createElementVNode("a", {
            href: __props.urlRechargeWallet,
            class: "btn btn-primary"
          }, " Dobít " + _toDisplayString(rechargeAmountFormatted.value), 9 /* TEXT, PROPS */, _hoisted_5)
        ])
      ])
    ])
  ]))
}
}

}